module.exports = __webpack_public_path__ + "img/youzanQRCode.6754892c.png";